import { render, staticRenderFns } from "./el-alert.vue?vue&type=template&id=06d5f856&scoped=true"
import script from "./el-alert.vue?vue&type=script&lang=js"
export * from "./el-alert.vue?vue&type=script&lang=js"
import style0 from "./el-alert.vue?vue&type=style&index=0&id=06d5f856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5f856",
  null
  
)

export default component.exports